"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Schedule = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Schedule(_a) {
    var livestream = _a.livestream, setLivestream = _a.setLivestream;
    return react_1.default.createElement(storybook_1.Cards.Card, { className: 'storybook-livestreams-form-schedule mb-4' },
        react_1.default.createElement(storybook_1.Cards.Content, null,
            react_1.default.createElement(storybook_1.Forms.Input, { className: 'mb-4', type: 'date', value: livestream.publishTime, onChange: function (publishTime) { return setLivestream({ publishTime: publishTime }); } }),
            react_1.default.createElement(storybook_1.Texts.Small, null, "Plan je video in door een datum en tijd in te vullen, je video wordt dan automatisch gepubliceerd.")));
}
exports.Schedule = Schedule;
